module.exports = __webpack_public_path__ + "static/media/stalkerig.93825ffc.png";